// Warm-up sets belong to the exercise (PlanExercise.warmup_sets): shown and
// logged before its working sets, marked `warmup` in the log and never counted
// as volume. `sets` / `reps` / `weight_kg` of a plan exercise are the working sets.

export const WARMUP_REST_SECONDS = 60;

const roundTo = (value, step) => Math.round(value / step) * step;

// An explicit weight wins; otherwise the percent of the working weight, rounded to 2,5 kg.
export const warmupWeight = (set, workKg) => {
  if (set.weight_kg != null) return set.weight_kg;
  if (set.percent && workKg) return roundTo((workKg * set.percent) / 100, 2.5);
  return null;
};

export const warmupsOf = (planEx) => (planEx.warmup_sets || []).map(set => ({
  reps: set.reps || '',
  percent: set.percent ?? null,
  weight: warmupWeight(set, planEx.weight_kg),
}));

const kg = (w) => String(w).replace('.', ',');

// "8 × 60 kg" / "10 × ok. 50%" / "10 powt."
export const warmupText = (w) => {
  const load = w.weight != null ? `${kg(w.weight)} kg` : w.percent ? `ok. ${w.percent}%` : null;
  const reps = w.reps || '?';
  return load ? `${reps} × ${load}` : `${reps} powt.`;
};

export const newWarmupSet = () => ({ reps: '10', percent: 50, weight_kg: null });
